'use client';

import Link from 'next/link';
import { marketplacePurchaseDisclosure } from '@/platform/legal/marketplacePolicy';
import { siteBrandName } from '@/platform/legal/siteLegal';

type Props = {
  storeName?: string;
  accepted: boolean;
  onAcceptedChange: (value: boolean) => void;
};

export function MarketplacePurchaseDisclosure({ storeName, accepted, onAcceptedChange }: Props) {
  const sellerLabel = storeName ? storeName : 'the vendor';
  const brand = siteBrandName();
  const disclosure = marketplacePurchaseDisclosure(brand);

  return (
    <div className="marketplace-disclosure feed-card settings-page">
      <h3>Marketplace purchase notice</h3>
      <ul className="marketplace-disclosure__list">
        <li>
          You are purchasing from <strong>{sellerLabel}</strong>, an independent seller—not from {brand}.
        </li>
        <li>{disclosure.verification}</li>
        <li>{disclosure.noReturns}</li>
        <li>{disclosure.contactVendor}</li>
        <li>{disclosure.governance}</li>
      </ul>
      <p>
        <Link href="/legal/marketplace/">Read the full marketplace policy</Link>
      </p>
      <label>
        <input type="checkbox" checked={accepted} onChange={(e) => onAcceptedChange(e.target.checked)} /> I
        understand this purchase is with the vendor and {brand} does not handle returns or refunds.
      </label>
    </div>
  );
}
